const Default = React.lazy(() => import("./Default"));
export { Default };
import Ingoing from "./Ingoing";
export { Ingoing };
import Outgoing from "./Outgoing";
import React from "react";
export { Outgoing };
